exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1pgs2QG2dkTYP23m_-v8DK{display:flex;flex-flow:column;height:100%;font-size:15px;line-height:22px}.QWlEsIvG3jnixRiuXN1yB{cursor:pointer;background:#e0e0e0;color:#616161;font-weight:500;font-size:13px;line-height:17px;padding:16px 0;display:flex;align-items:center}.QWlEsIvG3jnixRiuXN1yB svg{margin:0 10px}._26mMDQN9Meh1OmNaOKMVxd{background-color:#6982ff;color:#fff;padding:15px;text-align:center;font-size:16px;line-height:20px}._1bTFOXrX5iFFoHOSCoyIDX{overflow-y:auto;flex:0 1 auto;height:100%}._29jCVKwBJP4Zm0jkDExrVJ{padding:15px 10px}.B1xGrMHP4VV2o0tqQCZVq{border-top:1px solid #e0e0e0;padding:10px}\n", ""]);

// Exports
exports.locals = {
	"RightSidebar": "_1pgs2QG2dkTYP23m_-v8DK",
	"returnToPlanner": "QWlEsIvG3jnixRiuXN1yB",
	"header": "_26mMDQN9Meh1OmNaOKMVxd",
	"scrollContainer": "_1bTFOXrX5iFFoHOSCoyIDX",
	"topHalf": "_29jCVKwBJP4Zm0jkDExrVJ",
	"bottomHalf": "B1xGrMHP4VV2o0tqQCZVq"
};